import client from '@/api/client.js';
//import i18n from '@/plugins/i18n.js';
import store from "@/store";


export default {
    methods: {
        async getOrderView(jobId) {
            var meta = { clientApiMethod: 'getPartsFromJob', input: { jobId: jobId } };
            var response = await client().get(store.state.apiRouteRoot + "order/job/" + jobId, { meta: meta });
            return response?.data;
        },

        async getOrderDetailById(detailId) {
            var meta = { clientApiMethod: 'getOrderDetailById', input: { detailId: detailId } }
            var response = await client().get(store.state.apiRouteRoot + "OrderDetail/" + detailId, { meta: meta });
            return response?.data;
        },

        async generateOrderDetailDraft(dto) {
            var meta = { clientApiMethod: 'generateOrderDetailDraft', input: { dto: dto } };
            var response = await client().post(store.state.apiRouteRoot + "OrderDetail/Draft", dto, { meta: meta })
            return response?.data;
        },

        //compose article description from order detail data
        async composeArticleDescription(dto) {
            var meta = { clientApiMethod: 'composeArticleDescription', input: { dto: dto } };
            var response = await client().post(`${store.state.apiRouteRoot}OrderDetail/ComposeArticleDescription`, dto, { meta: meta });
            return response.data;
        },

        async createOrderDetail(newdetail) {
            var meta = {
                clientApiMethod: 'createOrderDetail',
                input: { newdetail },
                //successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().put(store.state.apiRouteRoot + "OrderDetail/", newdetail, { meta: meta })
            return response?.data;
        },

        async updateOrderDetail(detail) {
            var meta = {
                clientApiMethod: 'updateOrderDetail',
                input: { detail },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "OrderDetail/", detail, { meta: meta })
            return response?.data;
        },

        async deleteOrderDetail(detailId) {
            var meta = {
                clientApiMethod: 'deleteOrderDetail',
                input: { detailId: detailId },
                //successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "OrderDetail/" + detailId, { meta: meta })
            return response?.data;
        },
    }
}